import React from 'react'
import { DialogContent, LinearProgress, Typography } from '@material-ui/core'

const ModalProgressStep = ({ classes, progress }) => {
  return (
    <DialogContent>
      <div className={classes.container}>
        <div className={classes.progressContainer}>
          <LinearProgress
            variant="determinate"
            value={progress.percentage}
            className={classes.progressBar}
          />
          <Typography variant="body2" color="textSecondary">
            {progress.text}
          </Typography>
        </div>
      </div>
    </DialogContent>
  )
}

export default ModalProgressStep
